import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/wanghong-heiliao', label: '网红黑料' },
  { to: '/category/mingxing-bagua', label: '明星八卦' },
  { to: '/category/shehui-redian', label: '社会热点' },
  { to: '/category/yule-shendu', label: '娱乐深扒' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className={`flex items-center gap-2 transition-colors duration-300 ${
              isScrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            <span className="font-heading text-2xl md:text-3xl tracking-wide whitespace-nowrap">
              911爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-all duration-300 hover:opacity-80 whitespace-nowrap ${
                  location.pathname === link.to
                    ? isScrolled
                      ? 'text-primary-600'
                      : 'text-white border-b-2 border-white'
                    : isScrolled
                      ? 'text-foreground-700 hover:text-foreground-950'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer ${
                isScrolled
                  ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                  : 'text-white/70 hover:text-white hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full border text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'border-foreground-300 text-foreground-700 hover:border-foreground-500 hover:text-foreground-900'
                  : 'border-white/40 text-white hover:border-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              isScrolled ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors ${
                  location.pathname === link.to
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium px-3 py-2 rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}